import type {Session} from "@/src/modules/auth/types";

/** Client UTC anchor for WS `session:invalidated` race guard. */
export function stampSessionLoginAt(session: Session): Session {
  return {
    ...session,
    login_at: new Date().toISOString(),
  };
}
